import { useState, useEffect } from 'react';
import { contentService } from '../services/contentService';

export const useWebsiteContent = () => {
  const [content, setContent] = useState(null);
  const [landingHero, setLandingHero] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [source, setSource] = useState(null); // 'cache', 'api', or 'default'

  const loadContent = async () => {
    try {
      setLoading(true);
      setError(null);

      // Check cache status for debugging
      const cacheStatus = contentService.getCacheStatus();
      if (process.env.NODE_ENV === 'development') {
        console.log('📊 Cache status:', cacheStatus);
      }

      // Fetch both v1 and v2 content in parallel
      const [websiteContent, landingHeroContent] = await Promise.all([
        contentService.getWebsiteContent(),
        contentService.getLandingHeroContent()
      ]);
      
      console.log(websiteContent, 'Website Content');
      console.log(landingHeroContent, 'Landing Hero Content');

      setContent(websiteContent);
      setLandingHero(landingHeroContent);

      // Determine the source of content
      if (cacheStatus.hasCache && cacheStatus.isValid) {
        setSource('cache');
      } else if (
        websiteContent.version !== '1.0.0' ||
        websiteContent.sections.hero.title !==
          'Find Trusted Local Service Providers'
      ) {
        setSource('api');
      } else {
        setSource('default');
      }
    } catch (err) {
      console.error('Error loading website content:', err);
      setError(err.message);

      // Try to load default content as final fallback
      const defaultContent = contentService.getDefaultContent();
      const defaultLandingHero = contentService.getDefaultLandingHeroContent();
      setContent(defaultContent);
      setLandingHero(defaultLandingHero);
      setSource('default');
    } finally {
      setLoading(false);
    }
  };

  const refreshContent = async () => {
    // Force refresh by clearing cache first
    contentService.clearCache();
    await loadContent();
  };

  useEffect(() => {
    loadContent();
  }, []);

  return {
    content,
    landingHero,
    loading,
    error,
    source,
    refresh: refreshContent,
    clearCache: () => {
      contentService.clearCache();
      setContent(null);
      setLandingHero(null);
      setSource(null);
      loadContent();
    },
  };
};

